<app-question-card class="p-3">
  <div question>
    <img src="/assets/images/svg/thanks.svg" alt="thanks" class="img" />
    <p class="mb-3">Thank you for the details.</p>
    <div class="box-c">
      <p>Your cash offer request has been submitted. A real estate agent will reach out to you regarding your cash offer shortly.</p>
    </div>
  </div>
</app-question-card>
